import { ExpandableTable } from "../../../../components/UniversalTable";
import { documentTypeTableColumns } from "../../../../helpers";
import { PaystubItem } from "../../../../types/verified/paystub";
import { useMemo } from "react";
import { DocumentVerificationProvider } from "shared/types";
import { ExpandedTableRow } from "./slices/ExpandedTableRow";
import { createInscribePaystubRows } from "./utils";
import { resolveDocumentUrl } from "../../../../utils/fraudRisk";

const sortPaystubItems = (a: PaystubItem, b: PaystubItem) => {
  const dateA = a.income_source_data?.additional_data?.pay_period_start_date;
  const dateB = b.income_source_data?.additional_data?.pay_period_start_date;

  if (!dateA) return 1;
  if (!dateB) return -1;

  return new Date(dateB).getTime() - new Date(dateA).getTime();
};

export const PaystubTable = ({
  incomeItems = [],
  provider
}: {
  incomeItems?: PaystubItem[];
  provider: DocumentVerificationProvider;
}) => {
  const rows = useMemo(() => {
    if (provider === DocumentVerificationProvider.Inscribe) {
      const sortedIncomeItems = [...incomeItems].sort(sortPaystubItems);
      return createInscribePaystubRows(sortedIncomeItems);
    }

    const flatPaystubs = incomeItems.flatMap(
      (i) =>
        i.data?.document?.income_sources?.flatMap(
          (incSource) => incSource.pay_stubs
        ) ?? []
    );
    const flatWarnings = incomeItems.flatMap((i) =>
      (i.data?.document?.warnings || []).filter(
        (warning) => (warning as { type?: string }).type !== "name_mismatch"
      )
    );
    return [...flatWarnings, ...flatPaystubs].filter(Boolean);
  }, [incomeItems, provider]);

  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300 font-medium"
      renderExpanded={(row) => (
        <div className="p-6 bg-background-900">
          <ExpandedTableRow rowData={row} provider={provider} />
        </div>
      )}
      rows={rows}
      columns={documentTypeTableColumns}
      getViewUrl={resolveDocumentUrl}
    />
  );
};
